import React from "react";
import { CategoryDetail, FunctionDetail, ProgramContainer } from "../../../entities/formTemplateDataType";
import { Heading1, Heading4 } from "../../../theme";
import { ErrorAlertComponent } from "../../odsCalloutBox/ErrorAlertComponent";
import CMAUtils from "../../../utilities/CMAUtils";
import { TemplateStatus } from "../../../entities/Constants";
import { getAzureUserInfo } from "../../../security/UserComponent";
 
interface Props {
    isEng: boolean;
    programContainer: ProgramContainer;
    callbackStepIndex?: (index: number, returnIndex?:number) => void;
    callback:(programContainer: ProgramContainer)=>void;
    callbackValueSaved
}
 
interface State {
    showError: boolean;
    boxChecked1: boolean;
    boxChecked2: boolean;
}
 
export class CMAReviewComponent extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            showError: false,
            boxChecked1: false,
            boxChecked2: false,
        }
    }
    reviewPageIndex = 4;
    functionContent = (f: FunctionDetail, index: number, sectionIndex: number) => {
        let htmlString = [];
        let categoryHtml = [];
        const functionName = this.props.isEng ? f.FunctionName : (this.props.programContainer.FunctionNameList.find(fun => fun.code == f.FunctionName).FRA)
        console.log(f.CategoryDetailList)
        f.CategoryDetailList.forEach((c, index) =>{
            categoryHtml.push(this.categoryContent(c, index, sectionIndex));
            sectionIndex = sectionIndex + 1;
        });
        htmlString.push(
            <div className="ontario-summary-list">
                <div className="ontario-summary-list-heading__container">
                    <h3 className="ontario-summary-list__heading">{(this.props.isEng ? "Summary function " : "Fonctions de synthèse ") + String(index+1) + ": "} {functionName}</h3>
                </div>
                <dl className="ontario-summary-list__container">
                    {categoryHtml}
                </dl>
            </div>
        );
        return htmlString;
    }

    calculateFunctionScore = (functionIndex: number) => {
        let startIndex = this.reviewPageIndex+1;
        // const currentTemplate = this.props.programContainer.CMATemplateList[0];
        const currentTemplate = this.props.programContainer.Template;
        const functions = this.props.programContainer.CMATemplateList.filter(t=>t.Name==currentTemplate)[0].Functions;
        startIndex = functions.slice(0, functionIndex)
            .reduce((acc, f) => 
                acc + f.CategoryDetailList.length,
                startIndex
            );
        let endIndex = startIndex + functions[functionIndex].CategoryDetailList.length - 1;
        
        let questionCount = 0;
        let totalScore = 0;
        const sectionList = this.props.programContainer.ListOfFormSections;
        for (let i=startIndex; i <= endIndex; i++) {
            const eleList = sectionList[i].ListOfFormSubSections[0].ListOfFormSectionElements;
            totalScore = eleList.reduce((acc, ele) => acc + ele.Value?.level, totalScore);
            questionCount = questionCount + eleList.length;
        }
        return (Math.trunc((totalScore/questionCount)*10)/10);
    }

 
    calculateCategoryScore = (sectionIndex: number) => {
        const section = this.props.programContainer.ListOfFormSections[sectionIndex];
        const eleList = section.ListOfFormSubSections[0].ListOfFormSectionElements;
        const score = eleList.reduce((acc, ele) => acc + ele.Value?.level, 0.0) / eleList.length;
        return (Math.trunc(score*10)/10);
    }

    calculateOverallScore = () => {
        const currentTemplate = this.props.programContainer.Template;
        const functions = this.props.programContainer.CMATemplateList.filter(t=>t.Name==currentTemplate)[0].Functions;
        const totalScore = functions.reduce((acc, func, findex) => 
            this.calculateFunctionScore(findex) + acc,
            0
        );
        return (Math.trunc((totalScore/functions.length)*10)/10).toString();
    }
 
    categoryContent = (c: CategoryDetail, index: number, sectionIndex: number) => {
        const categoryName = this.props.isEng ? c.CategoryName : (this.props.programContainer.CategoryNameList.find(cat => cat.code == c.CategoryName).FRA)

        return(
            <div className="ontario-summary-list__row">
                <dt className="ontario-summary-list__key">
                    {(this.props.isEng ? ("Category " + String(index+1) + ": " + categoryName) : ("Catégorie " + String(index+1) + " : " + categoryName))}
                </dt>
                <dd className="ontario-summary-list__value">
                    {this.checkStatus(sectionIndex)}
                </dd>
                <dd className="ontario-summary-list__value">
                    {this.props.isEng ? "Rating:" : "Cotation :"} {this.calculateCategoryScore(sectionIndex)}
                </dd>
                <dd className="ontario-summary-list-button__container">
                    <a className="ontario-summary-list-change__button"
                     onClick={() => this.props.callbackStepIndex(sectionIndex)}>
                        {this.props.isEng ? "Change" : "Modifier"}
                    </a>
                </dd>
            </div>
        );
    }
    checkStatus = (sectionIndex: number) => {
        console.log(this.props.programContainer);
        const eleList = this.props.programContainer.ListOfFormSections[sectionIndex].ListOfFormSubSections[0].ListOfFormSectionElements;
        let completionCount = 0;
        eleList.forEach((ele) => {
            if (ele.Value) completionCount = completionCount + 1;
        })
        if (completionCount == 0) {
            return this.props.isEng ? "Not started yet" : "Non commencée";
        }
        else if (completionCount == eleList.length){
            return this.props.isEng ? "Completed" : "Terminée";
        }
        else {
            return this.props.isEng ? "In progress" : "En cours";
        }
    }
 
    render() {
        const p = this.props.programContainer;
        const functions = p.CMATemplateList.filter(cma=>cma.Name==p.Template)[0]?.Functions;
        let htmlString = [];
        let sectionIndex = this.reviewPageIndex + 1;
        const currentUser = getAzureUserInfo()?.name; // ?.idTokenClaims?.emails;
        htmlString.push(
            <ErrorAlertComponent
                bodyMsg={"Please check the box below to accept the collection and use of information."}
                title={"Please accept the Legal Disclaimer to proceed further"}
                isEng={true}
                Visible={this.state.showError}/>
        );
 
        htmlString.push(<Heading1>{this.props.isEng ? "Review your answers" : "Passez vos réponses en revue"}</Heading1>);
 
        functions.forEach((f, index) => {
            htmlString.push(this.functionContent(f, index, sectionIndex));
            sectionIndex = sectionIndex + f.CategoryDetailList.length;
        })
 
        // checkbox & declaration
       
        htmlString.push(
            <div className="ontario-form-group">
                <Heading4>{this.props.isEng ? "Ready for Approval" : "Prête pour approbation"}</Heading4>
                <fieldset className="ontario-fieldset">
                    <legend className="ontario-fieldset__legend">
                        {this.props.isEng ? "Declaration" : "Déclaration"}<strong className="ontario-label__flag" style={{ fontWeight: 'bold' }}>({this.props.isEng ? "required" : "obligatoire"})</strong>
                    </legend>
                    {this.state.showError && (!this.state.boxChecked1 || !this.state.boxChecked2) && <div className="ontario-error-messaging" role="alert">
                        <span className="ontario-error-messaging__icon">
                            <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </span>
                        <span className="ontario-error-messaging__content">
                             {this.props.isEng ? "You must accept the Declaration to submit the assessment for approval." : "Vous devez accepter la déclaration pour soumettre l'évaluation à l'approbation."}
                        </span>
                    </div>}
                    <div className="ontario-checkboxes">
                        <div className="ontario-checkboxes__item">
                            <input title="agreementcheckbox" className="ontario-checkboxes__input" id="declaration1" name="declaration1" type="checkbox" value="agree"
                                checked={this.state.boxChecked1} onChange={(e) => this.setState({boxChecked1: e.target.checked})}></input>
                            <label className="ontario-checkboxes__label" htmlFor="checkbox-option-1">
                               <p>{this.props.isEng ? "I affirm that this cyber security maturity assessment (CMA) ratings were derived from analysis of self-reported data provided by the organization. These CMA results reflect the current state of cyber security practices as perceived by the organization's personnel." : "J'affirme que les résultats de cette évaluation de la cybermaturité (ECM) ont été obtenus à partir de l'analyse des données autodéclarées fournies par l'organisation. Les résultats de l'ECM reflètent l'état actuel des pratiques de cybersécurité telles qu'elles sont perçues par le personnel de l'organisation."}</p>
                            </label>
                        </div>
 
                        <div className="ontario-checkboxes__item">
                             <input title="agreementcheckbox" className="ontario-checkboxes__input" id="declaration2" name="declaration2" type="checkbox" value="agree"
                                checked={this.state.boxChecked2} onChange={(e) => this.setState({boxChecked2: e.target.checked})}></input>
                            <label className="ontario-checkboxes__label" htmlFor="checkbox-option-2">
                                <p>{this.props.isEng ? "I understand that by submitting, my organization's Approver will be notified to review the assessment. They may provide feedback for updates, or approve the CMA results." : "Je comprends qu'en soumettant cette évaluation, la personne chargée de l'approuver au sein de mon organisation en sera informée en vue de son examen. Elle pourra recommander des mises à jour ou approuver les résultats de l'ECM."}</p>
                            </label>
                        </div>
                    </div>
                </fieldset>
            </div>
        );
 
        // buttons
        htmlString.push(
            <button className="ontario-button ontario-button--primary"
                onClick={() => {
                    if (!this.state.boxChecked1 || !this.state.boxChecked2) {
                        this.setState({showError: true});
                        window.scrollTo({top: 0, behavior: "smooth"})
                    } else{
                        this.props.programContainer.Entity.overallScore = this.calculateOverallScore();
                        CMAUtils.saveCMA(this.props.programContainer, TemplateStatus.APPROVAL_PENDING).then(success=>{
                            if(success){
                                 this.props.callbackValueSaved();
                            }
                        });
                        this.props.callback(p);
                        this.setState({ showError: false });
                    }
                }}
                >{this.props.isEng ? "Submit" : "Envoyer"}</button>
        );
 
       
 
        return htmlString;
    }
}